import { Clickable } from '@shared/Frontend/components/clickable'
import { SVGIconProps } from '@shared/Frontend/components/svg'
import * as React from 'react'
import { StyleguideExample, StyleguidePart } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsLinks = () => (
  <>
    <StyleguidePart title="WYSIWYG" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <div className="text--styled">
          <p>
            Integer posuere erat a ante venenatis <a href="#">donec ullamcorper nulla</a> aliquet. Vivamus sagittis
            lacus vel augue laoreet rutrum faucibus dolor auctor. Donec id elit non mi porta gravida at eget metus.
          </p>
        </div>
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="Default" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ObjectLink label="Ullamcorper nulla" />
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="Chevroned" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ObjectLinkChevron label={'Ullamcorper nulla'}/>
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

const sharedProps = {
  elementKind: 'link' as 'link',
  styleKind: 'link' as 'link',
  url: '#',
  isExternal: false
}

export const ObjectLink = (p: ObjectLinkProps & { icon?: SVGIconProps['id'] }) => (
  <Clickable {...sharedProps} title={p.label} className={`link ${p.extraClasses || ''}`} icon={p.icon} />
)

export const ObjectLinkChevron = (p: ObjectLinkProps) => (
  <Clickable {...sharedProps} icon="chevron-right" title={p.label} className={`link-chevron ${p.extraClasses || ''}`} />
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------          Types        ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

type ObjectLinkProps = {
  label: string
  extraClasses?: string
}
